<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link to="/admin/customers" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>Edit Customer</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="newCustomerForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-8 form-div">
                <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  label="First Name *"
                  label-for="firstName"
                  class="text-left"
                >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'First name is required.',
                    }"
                  >
                    <b-form-input
                      id="firstName"
                      name="firstName"
                      placeholder="First Name"
                      v-model="form.firstName"
                    ></b-form-input>
                    <span class="form-errors">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  label="Last Name *"
                  label-for="lastName"
                  class="text-left"
                >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Last name is required.',
                    }"
                  >
                    <b-form-input
                      id="lastName"
                      name="lastName"
                      placeholder="Last Name"
                      v-model="form.lastName"
                    ></b-form-input>
                    <span class="form-errors">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  label="Email *"
                  label-for="email"
                  class="text-left"
                >
                  <ValidationProvider
                    name="email"
                    rules="required|email"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Email is required.',
                    }"
                  >
                    <b-form-input
                      id="email"
                      name="email"
                      placeholder="Email"
                      v-model="form.email"
                    ></b-form-input>
                    <span class="form-errors">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  label="Phone *"
                  label-for="phone"
                  class="text-left"
                >
                  <ValidationProvider
                    name="phone"
                    rules="required|numeric"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Phone is required.',
                    }"
                  >
                    <b-form-input
                      id="phone"
                      name="phone"
                      placeholder="Phone"
                      v-model="form.phone"
                    ></b-form-input>
                    <span class="form-errors">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  label="Last Name *"
                  label-for="lastName"
                  class="text-left"
                >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Address is required.',
                    }"
                  >
                    <b-form-textarea
                      id="textarea"
                      v-model="form.address"
                      placeholder="Address"
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                    <span class="form-errors">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  label="Password *"
                  label-for="password"
                  class="text-left"
                >
                  <ValidationProvider
                    name="password"
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Password is required.',
                    }"
                  >
                    <b-form-input
                      type="password"
                      id="password"
                      name="password"
                      placeholder="Password"
                      v-model="form.password"
                    ></b-form-input>
                    <span class="form-errors">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group
                  id="fieldset-horizontal"
                  label-cols-sm="3"
                  label-cols-lg="2"
                  label="Confirm Password *"
                  label-for="password"
                  class="text-left"
                >
                  <ValidationProvider
                    name="confirm password"
                    rules="required|confirmed:password"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Please confirm password.',
                    }"
                  >
                    <b-form-input
                      type="password"
                      id="rePassword"
                      name="rePassword"
                      placeholder="Confirm Password"
                      v-model="form.rePassword"
                    ></b-form-input>
                    <span class="form-errors">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-form-group>

                <div class="fo-row-btn text-right">
                  <router-link
                    to="/admin/customers"
                    class="btn btn-secondary font-weight-bold px-9 py-4 my-3 font-size-3 mr-5"
                    >Abbrechen</router-link
                  >
                  <button
                    :disabled="isDisabled"
                    type="submit"
                    ref="kt_form_submit_btn"
                    class="btn submit-button font-weight-bold px-9 py-4 my-3 font-size-3 text-white"
                  >
                    Submit
                  </button>
                  <!-- <br />
              <span class="form-errors" v-if="formError"
                >One or more fields has error. Please check form again.</span
              > -->
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </div>
    </div>
    <notifications group="customers" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
Vue.use(Notifications);
export default {
  name: "EditCustomer",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.userId = localStorage.getItem("local_products_user_access_id");
      this.getCustomerData();
    }
  },
  data() {
    return {
      formError: false,
      userId: null,
      isLoading: false,
      pdfFileString: null,
      formData: [],
      pdfFileTest: "",
      btnDisable: false,
      form: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        address: null,
        password: null,
        rePassword: null,
      },
    };
  },
  methods: {
    getCustomerData() {
      axios
        .post("get-customer", { customer_id: this.$route.params.id })
        .then((response) => {
          var responseJson = response.data;
          if (responseJson.status == "success") {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.$notify({
              group: "customers",
              type: "error",
              position: "bottom right",
              text: responseJson.message,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.$notify({
            group: "customers",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    onSubmit() {
      this.$refs.newCustomerForm.validate().then((success) => {
        const submitButton = this.$refs["kt_form_submit_btn"];
        if (success) {
          this.formError = false;
          this.btnDisable = true;
          submitButton.classList.add(
            "spinner",
            "spinner-light",
            "spinner-right"
          );

          let formData = {
            first_name: this.form.firstName,
            last_name: this.form.lastName,
            email: this.form.email,
            phone: this.form.phone,
            address: this.form.address,
            password: this.form.password,
          };

          setTimeout(() => {
            axios
              .post("edit-customer", formData)
              .then((response) => {
                if (response.data.status == "success") {
                  submitButton.classList.remove(
                    "spinner",
                    "spinner-light",
                    "spinner-right"
                  );
                  this.$notify({
                    group: "customers",
                    type: "success",
                    position: "bottom right",
                    text: response.data.message,
                    duration: 5000,
                  });
                  setTimeout(() => {
                    this.$router.push({ name: "customers" });
                  }, 3000);
                } else {
                  this.btnDisable = false;
                  submitButton.classList.remove(
                    "spinner",
                    "spinner-light",
                    "spinner-right"
                  );
                  this.$notify({
                    group: "customers",
                    type: "error",
                    position: "bottom right",
                    text: response.data.message,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                submitButton.classList.remove(
                  "spinner",
                  "spinner-light",
                  "spinner-right"
                );
                this.$notify({
                  group: "customers",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.formError = true;
          this.btnDisable = false;
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        }
      });
    },
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}
.form-div {
  margin: auto;
}
.form-errors {
  color: red;
}
.submit-button {
  background-color: #3d5a80;
}
.submit-button:hover {
  background-color: #002c47;
}
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>
